import { Link } from "react-router-dom";
import { AlarmClock, Lock } from "lucide-react";
import { useFetch } from "../lib/api";
import { QuickChallanUpload } from "./QuickChallanUpload";

export const DeadlineBanner = () => {
  const { data: d, reload } = useFetch("/pe/my-deadline");
  if (!d?.show) return null;
  const what = d.missing.join(" and ");
  if (d.on_hold) return (
    <div className="mt-6 flex flex-wrap items-center gap-3 rounded-xl border border-rose-500/50 bg-rose-500/10 px-5 py-4 c-rise" data-testid="deadline-banner">
      <Lock size={20} className="text-rose-400 shrink-0" />
      <div className="text-sm text-rose-100 mr-auto"><b>Your payment for {d.month} is on hold.</b> {d.hold_reason || `${what} challan missing.`} Upload the paid challan to release it.</div>
      <Link to="/challans" className="text-xs text-rose-200 underline-offset-4 hover:underline" data-testid="deadline-banner-upload">All challans</Link>
      <QuickChallanUpload month={d.month} missing={d.missing} onUploaded={reload} />
    </div>);
  const late = d.days_left < 0;
  const urgent = d.days_left <= 2;
  return (
    <div className={`mt-6 flex flex-wrap items-center gap-4 rounded-xl border px-5 py-4 c-rise ${urgent ? "border-rose-500/50 bg-rose-500/10" : "border-amber-500/40 bg-amber-500/10"}`} data-testid="deadline-banner">
      <div className="text-center min-w-[64px]">
        <div className={`font-display text-4xl font-semibold leading-none ${urgent ? "text-rose-300" : "text-amber-300"}`} data-testid="deadline-days-left">{late ? 0 : d.days_left}</div>
        <div className="text-[10px] uppercase tracking-wider text-slate-400 mt-1">day{d.days_left === 1 ? "" : "s"} left</div>
      </div>
      <div className="text-sm mr-auto max-w-2xl">
        <div className="flex items-center gap-1.5 font-semibold"><AlarmClock size={15} />{what} challan for {d.month} not received</div>
        <div className="text-slate-300 text-xs mt-0.5">{late ? `It was due on ${d.due}. Your payment may be put on hold at any time.` : `Due on ${d.due}. If it's still missing, your payment may be put on hold from ${d.hold_on}.`}</div>
      </div>
      <Link to="/challans" className="text-xs text-slate-300 underline-offset-4 hover:underline" data-testid="deadline-banner-upload">All challans</Link>
      <QuickChallanUpload month={d.month} missing={d.missing} onUploaded={reload} />
    </div>);
};
